<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Contact</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/contact.PNG" class="img-fluid"/>
        <div class="card-text row" *ngIf="!preview && adService.isPartnerAdOfOther(favorite)">
            <div class="col-md-12">
                <app-partner-interest [favorite]="favorite"></app-partner-interest>
            </div>
        </div>
        <div class="card-text row" *ngIf="!preview && !adService.isPartnerAdOfOther(favorite)">
            <div class="col-md-4 indicateur">
                <label>Agence</label>
                <b>{{ favorite.ad.owner_name }}</b>
            </div>
            <div class="col-md-4 indicateur">
                <label>Référence</label>
                <b>{{ favorite.ad.owner_reference }}</b>
            </div>
            <div class="col-md-4 indicateur">
                <label>Adresse</label>
                <b>{{ favorite.ad.owner_adress }}</b>
            </div>
            <ng-container *ngFor="let contact of favorite.contacts; index as i;">
                <div class="bg-light bloc-list row m-2 mb-3">
                    <div class="col-11">
                        <mat-form-field>
                            <mat-label>Nom</mat-label>
                            <input matInput class="text" [(ngModel)]="contact.name" (ngModelChange)="edit($event)">
                        </mat-form-field>
                    </div>

                    <div class="dropdown dropstart d-inline-block col-1">
                        <button class="btn btn-outline btn-tool float-right"
                                id="dropdownFav-{{i}}" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-ellipsis-v"></i>
                        </button>
                        <div id="optionDropdown-{{i}}" class="dropdown-menu dropdown-menu-right"
                             aria-labelledby="dropdownFav" aria-haspopup="true" aria-expanded="false">
                            <ul class="pictoList">
                                <li>
                                    <a (click)="duplicateContact(i)">
                                        <i class="fa cfa cfa-clone"></i> Dupliquer
                                    </a>
                                </li>
                                <li class="delete">
                                    <a (click)="deleteContact(i)">
                                        <i class="fa cfa cfa-trash"></i>
                                        Supprimer
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-md-6">
                        <mat-form-field>
                            <mat-label>Téléphone</mat-label>
                            <input matInput class="text" [(ngModel)]="contact.phone" (ngModelChange)="edit($event)">
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-md-6">
                        <mat-form-field>
                            <mat-label>Email</mat-label>
                            <input matInput class="text" [(ngModel)]="contact.email" (ngModelChange)="edit($event)">
                        </mat-form-field>
                    </div>
                </div>
            </ng-container>
            <div class="col-md-12">
                <button (click)="addContact()" class="btn btn-outline mt-2 w-100 mb-3 mb-md-0">
                    <i class="fa cfa cfa-plus-circle"></i><span class="libelle">Ajouter un contact</span>
                </button>
            </div>
        </div>
    </div>
</div>
